var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect, useMemo } from 'react';
import { FormField, Button, Input, InputSelect } from '../../';
import { services } from '../../../../shared/api/services';
import './input-address.scss';
export var isValidAddress = function (address) {
    return !!((address.propertyName || address.propertyNumber) && address.road && address.town && address.postCode);
};
var DefaultValues = {
    addressSelection: null,
    postCode: null,
    addressDetails: null,
    showPostCodeLookup: true,
    showManualAddress: false,
    propertyName: '',
    propertyNumber: '',
    road: '',
    town: '',
    county: '',
    postcode: '',
    isInvalidClass: 'isInvalid',
    isRequiredClass: null,
    isMatchNotFound: false,
    showAddressFields: false,
    postcodeIsFetching: false,
};
export var InputAddress = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var register = _a.register, setValue = _a.setValue, errors = _a.errors, watch = _a.watch, value = _a.value, required = _a.required, name = _a.name, disabled = _a.disabled, _m = _a.setError, setError = _m === void 0 ? function () { } : _m, _o = _a.addAddressToValidate, addAddressToValidate = _o === void 0 ? function () { } : _o, _p = _a.removeAddressToValidate, removeAddressToValidate = _p === void 0 ? function () { } : _p, _q = _a.isDisplay, isDisplay = _q === void 0 ? true : _q;
    var defaultValues = __assign(__assign({}, DefaultValues), { required: required });
    //                                              #region states
    //                              #region flags to identify mode of address entry
    var _r = useState(defaultValues.showPostCodeLookup), showPostCodeLookup = _r[0], toggleShowPostCodeLookup = _r[1];
    var _s = useState(defaultValues.showManualAddress), showManualAddress = _s[0], toggleShowManualAddress = _s[1];
    //#endregion
    //                                          #region Address field values
    /**
     * stores the currently selected address options
     */
    var _t = useState(defaultValues.addressSelection), addressSelection = _t[0], setAddressSelection = _t[1];
    /**
     * stores post code lookup
     */
    var _u = useState(defaultValues.postCode), postCode = _u[0], setPostCode = _u[1];
    var _v = useState(defaultValues.propertyName), propertyName = _v[0], setPropertyName = _v[1];
    var _w = useState(defaultValues.propertyNumber), propertyNumber = _w[0], setPropertyNumber = _w[1];
    var _x = useState(defaultValues.road), road = _x[0], setRoad = _x[1];
    var _y = useState(defaultValues.town), town = _y[0], setTown = _y[1];
    var _z = useState(defaultValues.county), county = _z[0], setCounty = _z[1];
    var _0 = useState(defaultValues.postcode), postcode = _0[0], setPostcode = _0[1];
    //#endregion
    //                                        #region functionality states
    /**
     * stores if a class is required
     */
    var _1 = useState(defaultValues.isRequiredClass), isRequiredClass = _1[0], setIsRequiredClass = _1[1];
    /**
     * stores if a no addresses are found
     */
    var _2 = useState(defaultValues.isMatchNotFound), isMatchNotFound = _2[0], setIsMatchNotFound = _2[1];
    /**
     * stores if address fields are to be shown
     */
    var _3 = useState(defaultValues.showAddressFields), showAddressFields = _3[0], setShowAddressFields = _3[1];
    /**
     * stores if address list fetch is in progress
     */
    var _4 = useState(defaultValues.postcodeIsFetching), postcodeIsFetching = _4[0], setPostcodeIsFetching = _4[1];
    //#endregion
    //#endregion
    //                                              #region helpers
    /**
     * sets an error message for a specific field in the form.
     */
    var setPostcodeError = function (fieldKey, message) {
        setError(fieldKey, { message: message });
    };
    /**
     * function to concatenate name and id for identifying fields in form handler
     */
    var formatId = function (id, name) {
        return name ? "".concat(name, "-").concat(id) : id;
    };
    /**
     * function to reset field values
     */
    var resetFields = function () {
        setAddressSelection(defaultValues.addressSelection);
        setPostCode(defaultValues.postCode);
        setPropertyName(defaultValues.propertyName);
        setPropertyNumber(defaultValues.propertyNumber);
        setRoad(defaultValues.road);
        setTown(defaultValues.town);
        setCounty(defaultValues.county);
        setPostcode(defaultValues.postcode);
    };
    var requiredToggle = watch ? watch([formatId('propertyName', name), formatId('propertyNumber', name)]) : null;
    //#endregion
    //                                          #region action handlers
    /**
     * function to call the api that fetches addresses
     * if address is found, it is stored in addressSelection
     * if not isMatchNotFound is set to true
     * and error is generated in postcodeLookup field
     * @param {string} postCode - the postcode to be looked for
     */
    var handleFetchAddressList = function (postCode) { return __awaiter(void 0, void 0, void 0, function () {
        var res, addresses;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setPostcodeIsFetching(true);
                    return [4 /*yield*/, services.getAddressList(postCode.replace(' ', ''), "Postcode")];
                case 1:
                    res = (_a.sent()).data;
                    setPostcodeIsFetching(false);
                    if (Array.isArray(res) && res.length > 0) {
                        addresses = res.map(function (items) {
                            return { id: items.sid, value: items.itemText };
                        });
                        setAddressSelection(addresses);
                    }
                    else {
                        setAddressSelection(null);
                        setPostcodeError(formatId('postcodeLookup', name), 'Please enter a valid Post code.');
                        setIsMatchNotFound(true);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    /**
     * function to toggle address
     * resets fields, removes addressselection,
     * checks the last value of showPostCodeLookup and toggles showPostCodeLookup and showManualAddress
     */
    var handleManualAddressView = function () {
        resetFields();
        setAddressSelection(null);
        if (showPostCodeLookup)
            setShowAddressFields(true);
        else
            setShowAddressFields(false);
        toggleShowPostCodeLookup(!showPostCodeLookup);
        toggleShowManualAddress(!showManualAddress);
    };
    /**
     * function to handle onClick of find button
     */
    var handleFindAddress = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    e.stopPropagation();
                    setIsRequiredClass(true);
                    setAddressSelection(null);
                    setPropertyName(null);
                    setPropertyNumber(null);
                    setRoad(null);
                    setTown(null);
                    setCounty(null);
                    setPostcode(null);
                    toggleShowManualAddress(false);
                    setShowAddressFields(false);
                    setPostcodeError(formatId('postcodeLookup', name), null);
                    if (postCode == null || postCode == '') {
                        setAddressSelection(null);
                        setPostcodeError(formatId('postcodeLookup', name), 'Please enter a valid Post code.');
                    }
                    if (!postCode) return [3 /*break*/, 2];
                    return [4 /*yield*/, handleFetchAddressList(postCode)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    /**
     * function to handle onchange of postcodeLookup
     */
    var handlePostCodeEntry = function (e) {
        setShowAddressFields(false);
        setAddressSelection(null);
        setPostcodeError(formatId('postcodeLookup', name), !!e.currentTarget.value ? '' : 'Please enter a valid post code');
        setPostCode(e.currentTarget.value);
    };
    /**
     * function to call whenever user focuses out
     */
    var handleFocusOut = function (event) {
        if (!required) {
            setIsRequiredClass(false);
            setPostcodeError(formatId('postcodeLookup', name), null);
        }
    };
    /**
     * function to call whenever user selects an address after using postcode lookup
     */
    var handleAddressSelection = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var addressDetails, housenameLocal, flatLocal, organisationLocal, addressName;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getAddressDetail(e.currentTarget.value, 'Sid')];
                case 1: return [4 /*yield*/, (_a.sent()).data];
                case 2:
                    addressDetails = _a.sent();
                    setAddressSelection(null);
                    setPropertyName(null);
                    setPropertyNumber(null);
                    setRoad(null);
                    setTown(null);
                    setCounty(null);
                    setPostcode(null);
                    setShowAddressFields(true);
                    toggleShowManualAddress(true);
                    if (addressDetails.houseName2 != null && addressDetails.houseName2 != '') {
                        housenameLocal = addressDetails.houseName2;
                    }
                    else {
                        housenameLocal = '';
                    }
                    if (addressDetails.flat != null && addressDetails.flat != '') {
                        flatLocal = addressDetails.flat + ' ';
                    }
                    else {
                        flatLocal = '';
                    }
                    if (addressDetails.organisation != null && addressDetails.organisation != '') {
                        organisationLocal = addressDetails.organisation + ' ';
                    }
                    else {
                        organisationLocal = '';
                    }
                    addressName = organisationLocal + flatLocal + housenameLocal;
                    setPropertyName(addressName);
                    setPropertyNumber(addressDetails.houseName1);
                    setRoad(addressDetails.streetName1);
                    setTown(addressDetails.town);
                    setCounty(addressDetails.county);
                    setPostcode(addressDetails.postcode);
                    return [2 /*return*/];
            }
        });
    }); };
    //#endregion
    //                                          #region change monitors
    /**
     * runs everytime a new addressId is recieved. This is used to get data for already saved addresses
     */
    useEffect(function () {
        if (value) {
            services.getAddress(Number(value)).then(function (result) {
                if (result.data.postCode) {
                    setPropertyName(result.data.propertyName);
                    setPropertyNumber(result.data.propertyNumber);
                    setRoad(result.data.road);
                    setTown(result.data.town);
                    setCounty(result.data.county);
                    setPostcode(result.data.postCode);
                    toggleShowPostCodeLookup(false);
                    toggleShowManualAddress(true);
                    setShowAddressFields(true);
                }
            });
        }
    }, [value]);
    /**
     * Used to set error if match is not found
     */
    useEffect(function () {
        if (isMatchNotFound) {
            setAddressSelection(null);
            setPostcodeError(formatId('postcodeLookup', name), "No match found for Post code: ".concat(postCode));
            setIsMatchNotFound(false);
        }
    }, [isMatchNotFound]);
    useEffect(function () {
        setIsRequiredClass(required);
    }, [required]);
    /**
     * Used to generate a new random key and reset address form if it is hidden
     */
    var UUID = useMemo(function () {
        if (!isDisplay) {
            resetFields();
            removeAddressToValidate(name);
            setIsRequiredClass(defaultValues.isRequiredClass);
            setIsMatchNotFound(defaultValues.isMatchNotFound);
            setShowAddressFields(defaultValues.showAddressFields);
            toggleShowPostCodeLookup(defaultValues.showPostCodeLookup);
            toggleShowManualAddress(defaultValues.showManualAddress);
        }
        if (isDisplay)
            addAddressToValidate === null || addAddressToValidate === void 0 ? void 0 : addAddressToValidate(name);
        return (Math.random() * 100).toFixed(0);
    }, [isDisplay]);
    //#endregion
    return (React.createElement("fieldset", { key: UUID, className: "c-input-address" },
        React.createElement("legend", null, "Address"),
        showPostCodeLookup && (React.createElement(FormField, { id: formatId('postcodeLookup', name), label: "Post code", error: !addressSelection && !showAddressFields && ((_b = errors[formatId('postcodeLookup', name)]) === null || _b === void 0 ? void 0 : _b.message) },
            React.createElement("div", { className: "l-flex" },
                React.createElement("div", null,
                    React.createElement("input", { id: formatId('postcodeLookup', name), name: formatId('postcodeLookup', name), className: "c-input ".concat(!!((_c = errors[formatId('postcodeLookup', name)]) === null || _c === void 0 ? void 0 : _c.message) &&
                            !addressSelection &&
                            !showAddressFields &&
                            'isInvalid', " ").concat(required && 'isRequired'), type: "text", ref: register({
                            required: { value: isRequiredClass && !showAddressFields, message: 'Please enter a valid post code' },
                            validate: function (value) {
                                if (value &&
                                    !propertyName &&
                                    !propertyNumber &&
                                    (!addressSelection || addressSelection.length === 0) &&
                                    !postcodeIsFetching)
                                    return 'Please click find';
                                return true;
                            },
                        }), onChange: handlePostCodeEntry, onBlur: handleFocusOut, onKeyDown: function (e) {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        }, disabled: disabled })),
                React.createElement("div", null,
                    React.createElement(Button, { type: "submit", name: "findAddressButton", variant: "primary", onClick: handleFindAddress, disabled: disabled }, "Find"))))),
        addressSelection && showPostCodeLookup && (React.createElement(FormField, { label: "Select address", error: (_d = errors[formatId('select-address', name)]) === null || _d === void 0 ? void 0 : _d.message },
            React.createElement(InputSelect, { id: formatId('select-address', name), options: addressSelection, ref: register({
                    required: { value: addressSelection.length > 0, message: 'Please select a valid address' },
                }), childClasses: addressSelection.length > 0 ? 'isRequired' : '', error: errors[formatId('select-address', name)] &&
                    ((_e = errors[formatId('select-address', name)]) === null || _e === void 0 ? void 0 : _e.message) &&
                    addressSelection.length > 0, required: addressSelection.length > 0, forceSelection: true, onChange: handleAddressSelection }))),
        React.createElement(Button, { type: "button", variant: "bare", childClasses: "u-mb-2", onClick: handleManualAddressView }, !showPostCodeLookup ? 'Use Postcode lookup' : 'Enter address manually'),
        showAddressFields && (React.createElement(React.Fragment, null,
            React.createElement(FormField, { id: formatId('propertyName', name), label: "Property name" },
                React.createElement(Input, { id: formatId('propertyName', name), placeHolder: "Property Name", required: requiredToggle ? required && !(((_f = requiredToggle[formatId('propertyNumber', name)]) === null || _f === void 0 ? void 0 : _f.length) > 0) : true, error: !!errors[formatId('propertyName', name)] && !!errors[formatId('propertyName', name)], ref: register({
                        required: requiredToggle
                            ? required && !(((_g = requiredToggle[formatId('propertyNumber', name)]) === null || _g === void 0 ? void 0 : _g.length) > 0)
                            : true,
                    }), childClasses: (requiredToggle ? required && !(((_h = requiredToggle[formatId('propertyNumber', name)]) === null || _h === void 0 ? void 0 : _h.length) > 0) : true)
                        ? 'isRequired'
                        : '', setValue: setValue, value: propertyName, disabled: disabled })),
            React.createElement(FormField, { id: formatId('propertyNumber', name), label: "Property number", error: errors[formatId('propertyNumber', name)] &&
                    errors[formatId('propertyName', name)] &&
                    'Please enter a property name or number' },
                React.createElement(Input, { id: formatId('propertyNumber', name), placeHolder: "Property Number", required: requiredToggle ? required && !(((_j = requiredToggle[formatId('propertyName', name)]) === null || _j === void 0 ? void 0 : _j.length) > 0) : true, error: !!errors[formatId('propertyNumber', name)] && !!errors[formatId('propertyName', name)], ref: register({
                        required: requiredToggle
                            ? required && !(((_k = requiredToggle[formatId('propertyName', name)]) === null || _k === void 0 ? void 0 : _k.length) > 0)
                            : true,
                    }), childClasses: (requiredToggle ? required && !(((_l = requiredToggle[formatId('propertyName', name)]) === null || _l === void 0 ? void 0 : _l.length) > 0) : true)
                        ? 'isRequired'
                        : '', setValue: setValue, value: propertyNumber, disabled: disabled })),
            React.createElement(FormField, { id: formatId('road', name), label: "Road", error: errors[formatId('road', name)] && 'Please enter a valid road' },
                React.createElement(Input, { id: formatId('road', name), placeHolder: "Road", required: required, error: !!errors[formatId('road', name)], childClasses: required && 'isRequired', ref: register({ required: required }), setValue: setValue, value: road, disabled: disabled })),
            React.createElement(FormField, { id: formatId('town', name), label: "Town", error: errors[formatId('town', name)] && 'Please enter a valid town' },
                React.createElement(Input, { id: formatId('town', name), placeHolder: "Town", required: required, childClasses: required && 'isRequired', error: !!errors[formatId('town', name)], ref: register({ required: required }), setValue: setValue, value: town, disabled: disabled })),
            React.createElement(FormField, { id: formatId('county', name), label: "County", error: errors[formatId('county', name)] && 'Please enter a valid county' },
                React.createElement(Input, { id: formatId('county', name), required: false, error: !!errors[formatId('county', name)], placeHolder: "County", ref: register({ required: false }), setValue: setValue, disabled: disabled, value: county })),
            React.createElement(FormField, { id: formatId('postCode', name), label: "Post Code", error: errors[formatId('postCode', name)] && 'Please enter a valid postcode' },
                React.createElement(Input, { id: formatId('postCode', name), placeHolder: "Post Code", required: required, childClasses: required && 'isRequired', ref: register({ required: required }), error: !!errors[formatId('postCode', name)], setValue: setValue, value: postcode, disabled: disabled }))))));
};
